import { ApiService } from "../../services/ApiService.js";

/**
 * Fetches the main industry location data.
 * @param {string} locationId The ID of the location to fetch.
 * @returns {Promise<object>} A promise that resolves with the location data.
 */
export async function fetchIndustryData(locationId) {
  return await ApiService.fetch(`/wp-json/wp/v2/industry/${locationId}`);
}

/**
 * Fetches all logistic locations.
 * @returns {Promise<Array<object>>} A promise that resolves with an array of logistic locations.
 */
export async function fetchLogisticLocations() {
  return await ApiService.fetch("/wp-json/wp/v2/mps_logistic?per_page=100");
}

/**
 * Fetches the GeoJSON data for a specific OSM region.
 * @param {string|number} osmId The OpenStreetMap ID of the region.
 * @returns {Promise<object>} A promise that resolves with the GeoJSON data.
 */
export async function fetchRegionBoundary(osmId) {
  // These are static files, so a direct fetch is appropriate.
  const response = await fetch(`/wp-content/themes/iphub/osm/${osmId}.txt`);
  if (!response.ok) {
    throw new Error(`Failed to fetch boundary for OSM ID: ${osmId}`);
  }
  return await response.json();
}
